<h2 mat-dialog-title class="haendler-dialog-title">Kontakt auswählen</h2>

<div mat-dialog-content class="dialog-content">
    <kiene-gruppe-tier-betriebskontakt-haendler-zuordnen
        [dialog]="true"
        [tier]="tier"
        (saved)="onSaved($event)"
        #haendlerZuordnen
    >
    </kiene-gruppe-tier-betriebskontakt-haendler-zuordnen>
</div>

<div mat-dialog-actions align="end" class="dialog-actions">
    <button type="button" mat-button (click)="dialogRef.close()">Schließen</button>
</div>
